import type { HexaColor } from '@/interfaces/Colors.interfaces'

export const getRandomColor = (): HexaColor => {
  const letters = '0123456789ABCDEF'.split('')
  let color = ''
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return `#${color}`
}

const HEXA_COLOR_REGEX = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i

export const isHexaColor = (color: unknown): color is HexaColor =>
  typeof color === 'string' && HEXA_COLOR_REGEX.test(color)

export const textColorFromBg = (color?: string): HexaColor => {
  if (color) {
    const hex = color.substring(1, 7)
    const coefs = [0.21, 0.72, 0.07]
    let l = 0
    for (let i = 0; i < 3; i++) {
      const from = i * 2
      const c = parseInt(hex.substring(from, from + 2), 16) * coefs[i]
      l += c
    }
    const lightness = l / 255
    if (lightness > 0.5) {
      return '#000000'
    }
  }
  return '#ffffff'
}

// This helper has been intentionally left with errors to avoid potential side effects.
// `opacity || 1` result when opacity === 0 is 1. This behavior seems wierd and need to be checked. Should eventually be fixed by `opacity ?? 1`
// if opacity * 255 < 16 then returned value will only have 7 hexadecimal chars. Should fix opacity conversion with a padStart

export const addAlpha = (color: HexaColor, opacity = 0.5): string => {
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
  return color + _opacity.toString(16).toUpperCase()
}
